import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { ConfigInjector } from '@app/core/services/utils/injector';
import { PopinSize } from '@app/shared/utils';
import { ModalService } from '@app/core/services';
import { CoreFacade } from '@app/store/core/core.facade';
import { RCAlertType } from '@rc/ui';
import { IconName } from '@app/shared/utils/icon/icons';
import { getDateErrorMessage } from '@app/shared/utils/static-helpers/form-errors-helper';
import { RcPopinContentComponent } from '../rc-popin-content/rc-popin-content.component';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepicker } from '@angular/material/datepicker';
import { IconComponent } from '../../utils/icon/icon.component';
import { TranslatePipe } from '@app/shared/pipes';

export interface UpdateDatePopinComponentData {
  id: string;
  title: string;
  fieldLabel: string;
  subtitle: string;
  footerText: string;
  value: Date;
  validators: ValidatorFn[];
  minDate?: Date;
  maxDate?: Date;
}
export interface IUpdateDatePopinOutput {
  value?: VisitDate;
  id: string;
}

interface VisitDate {
  converted: string | null;
  original: Date;
}

@Component({
  selector: 'app-update-date-popin',
  templateUrl: './update-date-popin.component.html',
  styleUrls: ['./update-date-popin.component.scss'],
  providers: [DatePipe],
  imports: [
    RcPopinContentComponent,
    FormsModule,
    ReactiveFormsModule,
    MatInput,
    MatDatepickerInput,
    IconComponent,
    MatDatepicker,
    TitleCasePipe,
    TranslatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UpdateDatePopinComponent implements OnInit {
  public readonly IconName = IconName;
  public readonly PopinSize = PopinSize;
  public readonly AlertType = RCAlertType;

  form: UntypedFormGroup;
  visitDate?: VisitDate;
  submitted = false;
  data: UpdateDatePopinComponentData;
  title: string;
  subtitle: string;
  footerText: string;

  constructor(
    private modal: ModalService,
    private config: ConfigInjector,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private coreFacade: CoreFacade,
  ) {
    this.data = this.config.data;
  }

  ngOnInit(): void {
    this._setup();
  }

  onSubmitForm(event): void {
    event.preventDefault();

    try {
      this.visitDate = {
        converted: this.datePipe.transform(this.form.value.visitDate, 'shortDate'),
        original: this.form.value.visitDate,
      };

      this.dismiss();
      this.submitted = true;
    } catch (e) {
      this.dismiss();
      this.submitted = false;
      this.coreFacade.setAlert({ message: e, alertType: RCAlertType.ERROR, dataQa: 'vs-update-date-alert' });
    }
  }

  dismiss(): void {
    const output: IUpdateDatePopinOutput = {
      value: this.visitDate,
      id: this.data.id,
    };
    this.modal.close(output);
  }

  dateErrorMessage(): string {
    return (
      (this.form.controls.visitDate.touched &&
        this.form.controls.visitDate.errors &&
        getDateErrorMessage(this.form.controls.visitDate.errors, this.data.fieldLabel, true)) ||
      ''
    );
  }

  private _setup() {
    this.form = this.formBuilder.group({
      visitDate: [this.data.value, this.data.validators],
    });
    this.title = this.data.title;
    this.subtitle = this.data?.subtitle ? this.data?.subtitle : $localize`:@@dialog-update-date_desc:`;
    this.footerText = this.data.footerText;
  }
}
